/* SPS: open store policy links in a closable popup instead of a new page
   v9.6 (policy-URL package from Black Horse v2.3, with its Back-button bug fixed):
   - opening a policy shows /policies/<name> in the address bar and adds ONE history step, so the browser Back
     button closes the pop-up and leaves the visitor where they were;
   - switching policies inside the pop-up only updates the address (no extra steps);
   - x / Close / Esc / tap outside also undo that step (the address returns to the page);
   - a link to the policy page that is already open underneath closes the pop-up (Black Horse bug: it re-opened it);
   - tracking / session parameters are removed from the address bar 1.5 s after load. */
(function () {
  if (window.__spsPolicyModal) return;
  window.__spsPolicyModal = true;

  var POLICY_RE = /\/policies\/[^\/?#]+/;
  var PAGE = window.location.pathname;
  var cache = {};
  var ready = {};
  var modal = null;
  var titleEl = null;
  var bodyEl = null;
  var lastFocus = null;
  var token = 0;
  var pushed = false;
  var current = null;

  function withPreview(p) {
    var pv = null;
    try { pv = new URL(window.location.href).searchParams.get('preview_theme_id'); } catch (e) {}
    return p + (pv ? '?preview_theme_id=' + pv : '');
  }

  function setUrl(path) {
    current = path;
    try {
      if (!pushed) {
        history.pushState({ spsPm: 1 }, '', withPreview(path));
        pushed = true;
      } else {
        history.replaceState({ spsPm: 1 }, '', withPreview(path));
      }
    } catch (e) {}
  }

  function build() {
    if (modal) return;
    modal = document.createElement('div');
    modal.className = 'sps-pm';
    modal.hidden = true;
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'sps-pm-title');
    modal.innerHTML =
      '<div class="sps-pm__box">' +
        '<div class="sps-pm__head">' +
          '<h2 class="sps-pm__title" id="sps-pm-title"></h2>' +
          '<button type="button" class="sps-pm__close" aria-label="Close">&times;</button>' +
        '</div>' +
        '<div class="sps-pm__body" tabindex="0"></div>' +
        '<div class="sps-pm__foot"><button type="button" class="sps-pm__btn">Close</button></div>' +
      '</div>';
    document.body.appendChild(modal);
    titleEl = modal.querySelector('.sps-pm__title');
    bodyEl = modal.querySelector('.sps-pm__body');
    modal.querySelector('.sps-pm__close').addEventListener('click', function () { close(); });
    modal.querySelector('.sps-pm__btn').addEventListener('click', function () { close(); });
    modal.addEventListener('click', function (event) {
      if (event.target === modal) close();
    });
  }

  function show() {
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    modal.querySelector('.sps-pm__close').focus();
  }

  /* hide the pop-up only (no history change) */
  function hide() {
    token++;
    current = null;
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) {
      try { lastFocus.focus(); } catch (e) {}
    }
  }

  /* closed by the visitor: hide and undo the history step it added */
  function close() {
    hide();
    if (pushed) {
      pushed = false;
      try { history.back(); } catch (e) {}
    }
  }

  window.addEventListener('popstate', function (event) {
    if (pushed && !(event.state && event.state.spsPm)) {
      pushed = false;
      hide();
    }
  });

  function load(path) {
    if (cache[path]) return cache[path];
    var promise = fetch(path, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('http_' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var body = doc.querySelector('.shopify-policy__body');
        if (!body) throw new Error('no_body');
        var titleNode = doc.querySelector('.shopify-policy__title');
        var junk = body.querySelectorAll('script, style, iframe, form');
        for (var i = 0; i < junk.length; i++) {
          junk[i].parentNode.removeChild(junk[i]);
        }
        var data = {
          title: titleNode ? titleNode.textContent.trim() : '',
          html: body.innerHTML
        };
        ready[path] = data;
        return data;
      });
    cache[path] = promise;
    promise.catch(function () { delete cache[path]; });
    return promise;
  }

  function fixLinks() {
    var links = bodyEl.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      var href = a.getAttribute('href') || '';
      if (href.charAt(0) === '#' || a.protocol === 'mailto:' || a.protocol === 'tel:') continue;
      if (a.origin === window.location.origin && POLICY_RE.test(a.pathname)) {
        a.removeAttribute('target');
        continue;
      }
      a.target = '_blank';
      a.rel = 'noopener';
    }
  }

  function render(data, fallbackTitle) {
    titleEl.textContent = data.title || fallbackTitle || '';
    bodyEl.innerHTML = data.html;
    fixLinks();
    bodyEl.scrollTop = 0;
  }

  function openPolicy(path, trigger, fallbackTitle) {
    build();
    if (modal.hidden) lastFocus = trigger;
    setUrl(path);

    if (ready[path]) {
      render(ready[path], fallbackTitle);
      show();
      return;
    }

    var mine = ++token;
    var timer = setTimeout(function () {
      if (mine !== token) return;
      titleEl.textContent = fallbackTitle || '';
      bodyEl.innerHTML = '<div class="sps-pm__loading">Loading...</div>';
      show();
    }, 350);

    load(path)
      .then(function (data) {
        clearTimeout(timer);
        if (mine !== token) return;
        render(data, fallbackTitle);
        show();
      })
      .catch(function () {
        clearTimeout(timer);
        if (mine !== token) return;
        hide();
        window.location.href = path;
      });
  }

  function prefetch() {
    if (navigator.connection && navigator.connection.saveData) return;
    var links = document.querySelectorAll('a[href]');
    var paths = [];
    var seen = {};
    for (var i = 0; i < links.length; i++) {
      var url;
      try {
        url = new URL(links[i].href, window.location.href);
      } catch (e) {
        continue;
      }
      if (url.origin !== window.location.origin) continue;
      if (!POLICY_RE.test(url.pathname)) continue;
      if (url.pathname === PAGE) continue;
      if (seen[url.pathname]) continue;
      seen[url.pathname] = true;
      paths.push(url.pathname);
    }
    var index = 0;
    (function next() {
      if (index >= paths.length) return;
      var path = paths[index++];
      load(path)
        .catch(function () {})
        .then(function () { setTimeout(next, 150); });
    })();
  }

  function schedulePrefetch() {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(prefetch, { timeout: 4000 });
    } else {
      setTimeout(prefetch, 2000);
    }
  }

  if (document.readyState === 'complete') {
    schedulePrefetch();
  } else {
    window.addEventListener('load', schedulePrefetch);
  }

  document.addEventListener(
    'click',
    function (event) {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var target = event.target;
      var link = target && target.closest ? target.closest('a[href]') : null;
      if (!link) return;

      var url;
      try {
        url = new URL(link.href, window.location.href);
      } catch (e) {
        return;
      }
      if (url.origin !== window.location.origin) return;
      if (!POLICY_RE.test(url.pathname)) return;

      var open = modal && !modal.hidden;
      if (url.pathname === PAGE) {
        /* the policy page underneath: just close the pop-up (or do nothing if none is open) */
        if (open || pushed) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          close();
        }
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      if (open && url.pathname === current) return;
      openPolicy(url.pathname, link, (link.textContent || '').trim());
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && modal && !modal.hidden) close();
  });

  /* clean tracking / session parameters from the address bar (search, filters, variant and preview stay) */
  (function () {
    if (!window.location.search) return;
    var R = /^(pr_|utm_|_su_)|^(country|locale|currency|gclid|gbraid|wbraid|fbclid|msclkid|ttclid|twclid|srsltid|_gl|_pos|_sid|_ss|_kx|_psq|mc_cid|mc_eid|logged_in|customer_posted|contact_posted|form_type)$/i;
    function clean() {
      setTimeout(function () {
        if (pushed) return;
        var u = new URL(window.location.href), ks = [];
        u.searchParams.forEach(function (v, k) { if (R.test(k)) ks.push(k); });
        if (!ks.length) return;
        ks.forEach(function (k) { u.searchParams.delete(k); });
        history.replaceState(history.state, '', u.pathname + u.search + u.hash);
      }, 1500);
    }
    if (document.readyState === 'complete') clean(); else window.addEventListener('load', clean);
  })();
})();